import {
  PlaceOrderFormData,
  BasicFormSubmissionData,
  OrderData,
  BasicFormAnswer,
} from "types"
import { sanitizeFieldName } from "./contact-field-utils"

export const transformBasicFormData = (
  formData: PlaceOrderFormData,
  orderData: OrderData
): BasicFormSubmissionData => {
  const transformedData: BasicFormSubmissionData = {
    first_name: formData.contactInfo.firstName,
    last_name: formData.contactInfo.lastName,
    email: formData.contactInfo.email,
    answers: {},
  }

  orderData.ticket_set.forEach((ticket) => {
    const ticketAnswers = formData.tickets[ticket.id]

    transformedData.answers[ticket.id] = ticket.questions
      .map((question) => {
        const sanitizedFieldName = sanitizeFieldName(question.text)
        const fieldValue = ticketAnswers?.[sanitizedFieldName]

        // Only include answers that have actual values
        if (!fieldValue) return null
        const answer = Array.isArray(fieldValue)
          ? fieldValue.join(", ")
          : String(fieldValue)

        return {
          question_published: question.id,
          answer: answer,
        }
      })
      .filter((answer) => answer !== null) as BasicFormAnswer[]
  })

  return transformedData
}
